import { EstadosAlmacenesArticulos, EstadosArticulo } from "src/gql/schema"
export const TODOS_ALMACEN_FILTER = { label: "Todos", value: "Todos" }

export type MosaicFilter = {
    label: string
    value: {
        label: string
        value: EstadosArticulo | EstadosAlmacenesArticulos | "Todos"
    }
}

export const MOSAIC_ESTADO_FILTERS_ITEM_ALL: MosaicFilter = {
    label: "Todos",
    value: TODOS_ALMACEN_FILTER as MosaicFilter["value"],
}

export const MOSAIC_ESTADO_FILTERS: MosaicFilter[] = [
    MOSAIC_ESTADO_FILTERS_ITEM_ALL,
    {
        label: "Disponibles",
        value: {
            label: "Disponibles",
            value: EstadosAlmacenesArticulos.Disponible,
        },
    },
    {
        label: "Por agotarse",
        value: {
            label: "Por agotarse",
            value: EstadosAlmacenesArticulos.PorAgotarse,
        },
    },
    {
        label: "Agotado",
        value: {
            label: "Agotado",
            value: EstadosAlmacenesArticulos.Agotado,
        },
    },
    {
        label: "Desactivado",
        value: {
            label: "Desactivado",
            value: EstadosArticulo.Desactivado,
        },
    },
]

export type MosaicCategoryFilter = "Todos" | string
